import { Collapse, Descriptions } from "antd";
import { useTranslation } from "react-i18next";

/** Copia della riga VendorHub (fornitore o stabilimento), campo per campo, così come arriva dal dump. */
export function VendorhubData({ data }: { data: Record<string, string> | null }) {
  const { t } = useTranslation();
  const entries = Object.entries(data ?? {}).sort(([a], [b]) => a.localeCompare(b));
  if (!entries.length) return null;
  return (
    <Collapse
      size="small"
      items={[
        {
          key: "vh",
          label: `${t("f_vhData")} (${entries.length})`,
          children: (
            <Descriptions column={1} size="small" styles={{ label: { width: 200, fontFamily: "var(--ap-mono)", fontSize: 12 }, content: { overflowWrap: "anywhere" } }}>
              {entries.map(([k, v]) => (
                <Descriptions.Item key={k} label={k}>{v === "t" ? "true" : v === "f" ? "false" : v}</Descriptions.Item>
              ))}
            </Descriptions>
          ),
        },
      ]}
    />
  );
}
